import { Button, Col, Form, Row } from 'antd';
import { cloneDeep, isEmpty} from 'lodash';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormInputDate, FormInputMobile, FormRadioButton, FormSelect,
  FormTextInput } from '../../../../../../shared/components/crmFormElement/FormInput';
import { GUTTOR_SPACE, VALIDATE_MESSAGES } from '../../../../../../shared/constants/commonConstants';
import {
  BENEFICIARY_SEARCH_OPTION, BENEFICIARY_SEARCH_WITHOUT_POLICY, BENEFICIARY_SEARCH_WITH_ONLY_MEMBERID, BENEFICIARY_SEARCH_OPTION_COI,
  BENEFICIARY_SEARCH_WITH_POLICYNAME, DEFAULT_ADMISSION_FORM_VALUE,
  BENEFICIARY_SEARCH_WITH_CORPORATENAME, BENEFICIARY_SEARCH_WITH_CERTIFICATE_NO, BENEFICIARY_SEARCH_OPTION_ABHI,
  BENEFICIARY_SEARCH_WITH_ONLY_CLIENTID,
  POLICY_FIELD_FOR_RPA,
  DIFF_POLICY_OPTIONS_FOR,
  formInputStates,
  BENEF_CONSTANTS,
  CORPRATE_NAME_REGEX,
  POLICY_TYPE_OPTIONS,
} from '../../../../../../shared/constants/crmConstants';
import { RootState } from '../../../../../../store';
import * as actions from '../../../../../../store/actions/newAdmissionAction';
import ApplicationDetail from '../../../../../../shared/services/applicationDetail.service';
import { NHCXState } from '../../../../../../store/models/nhcxModel';
import { PayerInitialState } from '../../../../../../store/models/payerListModel';
import { centeredNotification, formatName, getMobileFormat } from '../../../../../../utils/utility';
import { getPolicyNoPattern, findKeyValuePair, memberIdValidation, memberIdValidationNivaBupa,
  otherPolicyValidation,
  patientNameValidation,
  getPayerConfigPropValue,
  prefillPolicyType,
  getIHave,
  updateInputStates,
  getInsurerDetails,
} from '../../../service/crmUtils';
import { ReactComponent as SearchIcon } from '../../../../../../assets/images/svg/Search_Icon.svg';
import { ReactComponent as DownArrow } from '../../../../../../assets/images/svg/DownArrow.svg';
import { setSelectedTab } from '../../../../../../store/actions/newAdmissionAction';
import moment from 'moment';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';

const RPABeneficiarySearchPanelRedesign = (props: any): ReactElement => {
  const { isLoading, benefFormOrigin, completeStep, resetSteps, admissionForm} = props;
  const [benefForm] = benefFormOrigin ? [benefFormOrigin] : Form.useForm();
  const [selectedBenefSearch, setSelectedBenefSearch] = useState('');
  const [selectedPolicyType, setSelectedPolicyType] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const [insurerFields, setInsurerFields] = useState<boolean>(false);
  const [retailOptionsCMSGI, setRetailOptionsCMSGI] = useState<boolean>(true);
  const [corporateOptionMDSV, setCorporateOptionMDSV] = useState<boolean>(false);
  const [insurerBajajFields, setInsurerBajajFields] = useState<boolean>(false);
  const [showCorporateName, setCorporateName] = useState<boolean>(false);
  const [showBajajCorporateName, setBajajCorporateName] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [enableRadio, setEnableRadio] = useState('employeeId');
  const [enableFirstRadio, setEnableFirstRadio] = useState('medicalId');
  const [requiredField, setRequiredField] = useState('employeeId');
  const [mandatoryFields, setMandatoryFields] = useState('policyNumber');
  const [isCertificateNoReq, setIsCertificateNoReq] = useState<boolean>(false);
  const [isShowPolicyNo, setIsShowPolicyNo] = useState<boolean>(false);
  const { payer: { isClaimCreationBlockedWithoutBenef, uniqueIdentifier, shortName,
    name: payerName, value: payerValue} }
    = useSelector((state: RootState): PayerInitialState => state.payerList);
  const { payerLookUp }: any = useSelector((state: RootState): RootState => state);
  const { memberSearchRequest }: any = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const formControlConfig = useSelector((state: RootState): any => state?.payerList?.formControlConfig || {});
  const payerConfigValues = Object.values(formControlConfig);
   const max = payerConfigValues?.filter(({ label, MAX }: any): boolean => label === 'CORPORATE_NAME' && MAX);
  const maximumValue = (max?.map((ele: any): any => ele?.MAX)?.length > 0) ? max?.map((ele: any): any => ele?.MAX) : false;
  const fieldLength = maximumValue ? max?.map((ele: any): any => ele?.maximumLength) : null;
  const minPropObj = payerConfigValues?.filter(({ MIN }: any): boolean => MIN);
  const isPolicyNoPatternCheckRequired =
    Boolean(payerConfigValues?.filter(({ checkPolicyNoPattern, hidden }: any): boolean =>
      checkPolicyNoPattern === true && !hidden)?.length);
  const { selectedPatientDetail, isAutomatedNewAdmission } = useSelector((state: RootState): any => state.hospital);
  const { patientDetails, treatmentDetails: hisTreatmentDetails } = selectedPatientDetail || {};
  const { insurerID } = patientDetails || memberSearchRequest || {};
  const { selectedPolicyDetail, memberName } = useSelector((state: RootState): NHCXState => state.nhcx);
  const beneficarySearchRequired = Boolean(payerConfigValues?.filter(({ type }: any): boolean => type === 'beneficiary_search')?.length);
  const isNHCXEnabledProvider = ApplicationDetail.instance.getIsNHCXEnabledProvider();
  const [benefSearchFields, setBenefSearchFields] = useState<any[]>([]);
  const [inputStates, setInputStates] = useState(formInputStates.RPARedesignBenefForm);
  const commonDetails = { loading, form: benefForm, isLoading };

  const disableBenefSearch = beneficarySearchRequired && isNHCXEnabledProvider; // To disabled Beneficiary Serach for Bajaj
  const onSearchChange = (value: any): void => {
    if (shortName === 'ICICI' && value !== 'Member ID' && value !== 'Policy No.') {
      setIsShowPolicyNo(true);
    } else {
      setIsShowPolicyNo(false);
    }
    setInsurerBajajFields(false);
    !(shortName === 'NIVA BUPA') && setBajajCorporateName(false);
    setSelectedBenefSearch(shortName === 'CARE' && value === 'Client ID' ? 'Member ID' : value);
    dispatch(actions.getSelectedSearchType(value));
    resetSteps(['memberSearch', 'memberCard']);
  };
  const validateFields = (): any => {
    setTimeout((): any => {
      benefForm
        ?.validateFields()
        .then((): any => {
          setDisable(true);
        })
        .catch((error: any): any => {
          const { errorFields } = error;
          if (errorFields?.length > 0) {
            setDisable(false);
          }
        });
    }, 200);
  };

  const initiateMemberForm = (): void => {
    admissionForm.resetFields();
    dispatch(actions.sethospDetailsForRoomType({}));
    dispatch(actions.setBeneficiaryList([]));
    dispatch(actions.setIsShowAdmissionForm(false));
    dispatch(actions.setSelectedBeneficiary(null));
    dispatch(actions.setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
    dispatch(actions.setUploadedFiles([]));
    dispatch(actions.setIsAbhaVerified(false, {}));
    dispatch(setSelectedTab(0));
    dispatch(actions.setHospitalOtherRoomType(''));
  };

  useEffect((): any => {
    checkRequiredField();
  }, [benefForm.getFieldsValue('iHave'), benefForm.getFieldsValue('policyType')]);

  useEffect((): void => {
    benefForm.setFieldsValue({
      Payer: payerValue,
      policyNumber: '',
      corporateName: '',
      memberId: '',
      patientName: '',
      employeeId: '',
      insurerName: [],
      policyType: [],
      policyName: '',
      status: '',
      mobile: '',
    });
    setInsurerFields(false);
    setBenefSearchFields(getSearchOption());
  }, [payerName]);

  useEffect((): void => {
    const defaultValue = benefSearchFields?.[0];
    benefForm.setFieldsValue({ iHave: defaultValue });
    onSearchChange(defaultValue);
  }, [benefSearchFields, payerName]);

  useEffect((): void => {
    setBenefSearchFields(getSearchOption());
  }, [retailOptionsCMSGI, insurerFields, showCorporateName]);

  const completeBenefSearchStep = (): void => {
    const stepName = !isEmpty(selectedPolicyDetail)
      ? 'memberSearch'
      : !isEmpty(selectedPatientDetail)
      ? 'memberOrPolicy'
      : 'memberSearch';

    completeStep(stepName);
  };

  const setFormFieldsAndUpdateStates = (fieldValues: any): void => {
    benefForm?.setFieldsValue(fieldValues);
    updateInputStates(fieldValues, setInputStates);
  };

  const handleHisMobNumber = (mobileNumber: string): void => {
    if (mobileNumber) {
      const mobile = getMobileFormat(mobileNumber);
      setFormFieldsAndUpdateStates({ mobile });
    }
  };

  const handleHisDOA = (dateOfAdmission: string): void => {
    if (dateOfAdmission) {
      // must use moment here as it uses the old datePicker
      if (dateOfAdmission && moment(dateOfAdmission).isValid()) {
        setFormFieldsAndUpdateStates({ dateOfAdmission: moment(dateOfAdmission) });
      }
    }
  };

  const handlePolicyType = (policyType: string): void => {
    if (policyType) {
      const policyOptions = DIFF_POLICY_OPTIONS_FOR.includes(shortName) ?
        POLICY_TYPE_OPTIONS.CUSTOMER_TYPES : POLICY_TYPE_OPTIONS.SECTOR_TYPES;
      prefillPolicyType(policyType, policyOptions, benefForm);
    }
  };

  useEffect((): void => {
    if (isAutomatedNewAdmission && !isEmpty(memberSearchRequest)) {
      const iHave = getIHave(memberSearchRequest, benefSearchFields);
      onSearchChange(iHave);
      const patientName = formatName(memberSearchRequest?.memberName);

      setFormFieldsAndUpdateStates({
        ...memberSearchRequest,
        iHave,
        patientName,
      });

      handleHisMobNumber(memberSearchRequest?.mobileNumber);
      handleHisDOA(memberSearchRequest?.dateOfAdmission);
      handlePolicyType(memberSearchRequest?.policyType);

      completeBenefSearchStep();
      return;
    }

    if (!isEmpty(selectedPatientDetail)) {
      // Update benefForm and input states with patient fields
      setFormFieldsAndUpdateStates(patientDetails);

      handleHisMobNumber(patientDetails?.mobileNumber);
      handleHisDOA(hisTreatmentDetails?.dateOfAdmission);

      // Format and set patient name
      const patientName = formatName(patientDetails?.memberName || patientDetails?.patientName);
      setFormFieldsAndUpdateStates({ patientName });

      handlePolicyType(patientDetails?.policyType);
    }

    if (!isEmpty(selectedPolicyDetail)) {
      const policyNumber = selectedPolicyDetail?.productId?.split('|')[1] || '';
      const policyFields = {
        memberId: selectedPolicyDetail?.memberId,
        patientName: memberName,
        policyNumber,
      };
      // Update benefForm and input states with policy fields
      setFormFieldsAndUpdateStates(policyFields);
    }
  }, [selectedPatientDetail, selectedPolicyDetail, payerValue, memberSearchRequest]);

  useEffect((): void => {
    if (!isEmpty(patientDetails)) {
      // setting insurerName received from HIS to undefined since we will only use insurerName from payerLookUp insurerID mapping
      patientDetails.insurerName = undefined;
      if (insurerID) {
        const insurerName = getInsurerDetails(insurerID, payerLookUp[uniqueIdentifier]);
        if (insurerName) {
          // updating patientDetails to always have the insurerName from payerLookup
          patientDetails.insurerName = insurerName;
          setFormFieldsAndUpdateStates({ insurerName });
          dispatch(actions.setInsurerID(insurerID));
        }
      }
    }
  }, [payerLookUp[uniqueIdentifier]]);

  const updateBeneficiaryList = (benefList: any[]): void => {
    setLoading(false);
    dispatch(actions.setBeneficiaryList(benefList));
    completeBenefSearchStep();
  };

  const failedBeneficiarySearch = (errorMsg: string, allowNextStage: any, errorResponse: any): void => {
    if (errorResponse === 'Bad Gateway') { // checking for 502 error
      centeredNotification('Details not found , Please submit a claim on IHX');
    } else {
      if (!errorResponse) {
        centeredNotification(errorMsg);
      }
    }
    let enableManual = false;
    setLoading(false);
    if (!isClaimCreationBlockedWithoutBenef) { // disabling claim creation when the flag is true irrespective of the allowNext stage
      enableManual = String(allowNextStage)?.toUpperCase() !== 'NO';
  } //   IPP-3655
    if (enableManual) {
      completeStep('memberOrPolicy');
      completeStep('memberSearch');
      completeStep('memberCard');
      dispatch(actions.enableManualSubmission());
      enableAdmissionForm();
    }
  };

  const enableAdmissionForm = (): void => {
    dispatch(actions.setIsShowAdmissionForm(true));
    dispatch(actions.setSelectedBeneficiary(null));
  };

  const onClickSearch = (formVal: any): void => {
    validateFields();
    initiateMemberForm();
    dispatch(actions.setSelectedCardIndex(-1));
    if (isEmpty(selectedPolicyDetail)) {
      resetSteps(['memberSearch', 'memberOrPolicy', 'documentsAttached', 'claimReviewed', 'memberCard']);
    } else if (!isEmpty(selectedPolicyDetail)) {
      resetSteps(['memberSearch', 'documentsAttached', 'claimReviewed', 'memberCard']);
    }
    const newAdminssionSearchVal = {
      ...formVal,
      fullName: formVal?.patientName || '',
      payer: payerName,
    };
    updateInputStates(newAdminssionSearchVal, setInputStates, '.his-search-row-cont input', { resetFocus: true, blurDomInputs: true });

    if (Object.keys(formVal).length) {
      setLoading(true);
      dispatch(actions.setNewAdminssionSearchVal(newAdminssionSearchVal));
      if (!disableBenefSearch) {
        dispatch(actions.benefSearch(formVal, updateBeneficiaryList, failedBeneficiarySearch));
      } else { // to allow submisison for Bajaj (NHCX) without beneficiary search
        centeredNotification('Details not found , Please submit a claim on IHX');
        dispatch(actions.enableManualSubmission());
        enableAdmissionForm();
        completeStep('memberOrPolicy');
        completeStep('memberSearch');
        completeStep('memberCard');
        setLoading(false);
      }
    }
  };

  const onInsurerNameChange = (selectedInsurer: any): any => {
    if (selectedInsurer) {
      const { payerMasterValue: insurerId } =
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'name', selectedInsurer) ||
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'value', selectedInsurer) ||
        {};
      dispatch(actions.setInsurerID(insurerId));
    }
  };
  const onCorporateNameChange = (selectedCorporate: any): any => {
    if (selectedCorporate) {
      const { payerMasterValue: corporateName } =
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.corporate_name, 'name', selectedCorporate) ||
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.corporate_name, 'value', selectedCorporate) ||
        {};
      dispatch(actions.setCorporateName(corporateName));
    }
  };
  const onSelectRadio = (event: any): any => {
    if (event?.target?.value === 'Employee ID') {
      setEnableRadio('employeeId');
    } else {
      setEnableRadio('corporateName');
    }
  };
  const onSelectFirstRadio = (event: any): any => {
    if (event?.target?.value === 'Member ID') {
      setEnableFirstRadio('medicalId');
    } else {
      setEnableFirstRadio('policyNumber');
    }
  };
  const updateFields = (): any => {
    const { policyType } = benefForm?.getFieldsValue(['policyType']);
    setSelectedPolicyType(policyType);
    if (policyType === 'Retail') {
      setCorporateOptionMDSV(false);
      setRetailOptionsCMSGI(true);
      setInsurerFields(true);
      setCorporateName(false);
    } else if (policyType === 'Corporate' && shortName === 'CMSGI') {
      setRetailOptionsCMSGI(false);
      setCorporateName(true);
      setInsurerFields(false);
    } else if (policyType === 'Corporate' && shortName === 'MDSV') {
      setCorporateOptionMDSV(true);
    } else if ((shortName === 'HERITAGE' || shortName === 'VOLO' || shortName === 'PHSI') && policyType === 'Corporate') {
      setCorporateName(true);
      setInsurerFields(false);
    }
  };

  // for showing the policy no, emp id, mobile no fields for bajaj
  const bajajFields = (): any => {
    const { policyType } = benefForm?.getFieldsValue(['policyType']);
    setSelectedPolicyType(policyType);
    if (policyType) {
      setInsurerBajajFields(true);
      setBajajCorporateName(false);
    }
    if (policyType === 'Group') {
      setBajajCorporateName(true);
    }
  };

  // for making the employee id and mobile no field optional
  const checkRequiredField = (): any => {
    const { employeeId, mobile, policyNumber } = benefForm.getFieldsValue(['employeeId', 'mobile', 'policyNumber']);
    if (shortName === 'Bajaj') {
      if (employeeId && !mobile) {
        setRequiredField('employeeId');
      } else if (!employeeId && mobile && mobile.slice(3).trim().length > 0) {
        setRequiredField('mobile');
      } else {
        setRequiredField('employeeId');
      }
    }
    if (isPolicyNoPatternCheckRequired && policyNumber) {
      setIsCertificateNoReq(getPolicyNoPattern(policyNumber || ''));
    }
  };

  // for making the insurance card number and policy no field optional
  const checkMandatoryFields = (): any => {
    if (shortName === 'PHSI') {
      const { insuranceCardNumber, policyNumber } = benefForm.getFieldsValue(['insuranceCardNumber', 'policyNumber']);
      if (insuranceCardNumber && !policyNumber) {
        setMandatoryFields('insuranceCardNumber');
      } else if (!insuranceCardNumber && policyNumber) {
        setMandatoryFields('policyNumber');
      } else {
        setMandatoryFields('policyNumber');
      }
    }
  };

  const handleUserFocus = (key: string): void => {
    setInputStates((prevState: any): any => ({
      ...prevState,
      [key]: {
        isFocused: true,
        hasValue: !!benefForm?.getFieldValue(key),
      },
    }));
  };

  const handleUserUnFocus = (key: string, e: React.FocusEvent<HTMLInputElement>): void => {
    const value = e?.target?.value;
    setInputStates((prevState: any): any => ({
      ...prevState,
      [key]: {
        isFocused: false,
        hasValue: !!value,
      },
    }));
  };

  // Function to determine the column width based on shortName
  const getPolicyNumberColumnWidth = (): number => {
    if (['CMSGI', 'NIVA BUPA'].includes(shortName)) {
      return 24;
    }
    if (['VOLO', 'MDSV', 'HERITAGE', 'PHSI', 'SHAI', 'ICICI', 'VIDAL'].includes(shortName)) {
      return 10;
    }
    return 14;
  };

  // Function to determine the className based on shortName
  const getPolicyNumberClassName = (): string => {
    if (['MDSV', 'HERITAGE', 'PHSI', 'ICICI'].includes(shortName)) {
      return 'beneficiary-search-using rbr-0 RPA-VOLO';
    }
    if (['Bajaj', 'CMSGI', 'NIVA BUPA', 'VOLO', 'VIDAL'].includes(shortName)) {
      return 'beneficiary-search-using';
    }
    if (shortName === 'SHAI') {
      return 'star-fields-row rbr-0 RPA-VOLO';
    }
    return '';
  };

  const resetRPABenefSearch = (): void => {
    if ( isAutomatedNewAdmission ) {
      return;
    }
    if (isEmpty(selectedPolicyDetail)) {
      resetSteps(['memberSearch', 'memberOrPolicy', 'documentsAttached', 'claimReviewed', 'memberCard']);
    } else if (!isEmpty(selectedPolicyDetail)) {
      resetSteps(['memberSearch', 'documentsAttached', 'claimReviewed', 'memberCard']);
    }
    initiateMemberForm();
  };

  const getSearchUI = (): (ReactElement | null) => {
    if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[0] || selectedBenefSearch === BENEFICIARY_SEARCH_WITH_CORPORATENAME[0]) {
      return <React.Fragment>
        <Row gutter={GUTTOR_SPACE}>
          <Col md={['VIDAL', 'TNNHIS', 'Bajaj', 'CMSGI', 'FHPL', 'VOLO', 'NIVA BUPA', 'PHSI', 'ICICI', 'GODIGIT'].includes(shortName) ?
          24 : (shortName === 'CARE') ? 14 : (shortName === 'MDSV' || shortName === 'HERITAGE' || shortName === 'SHAI') ? 10 : 7}
            className={(['VIDAL', 'TNNHIS', 'Bajaj', 'ICICI'].includes(shortName) && selectedBenefSearch === 'Member ID') ?
            'RPA-member-id-only' : (shortName === 'MDSV' || shortName === 'HERITAGE') ? 'beneficiary-search-using rbr-0 RPA-VOLO' :
            (shortName === 'SHAI') ? 'star-fields-row rbr-0 RPA-VOLO' : 'beneficiary-search-using'}>
            <FormTextInput detail={{
              ...commonDetails,
              key: 'memberId',
              isLoading,
              rules: [
                ...(shortName === 'PHSI' ? [memberIdValidation] : shortName === 'NIVA BUPA' ? [memberIdValidationNivaBupa] : []),
              ],
              className: 'HISSearchUI',
              minLengthValue: getPayerConfigPropValue(minPropObj, 'MIN', 'memberId'),
              fieldLengthValue: [getPayerConfigPropValue(minPropObj, 'minimumLength', 'memberId')],
              onFocus: (): any => handleUserFocus('memberId'),
              onBlur: (e: any): any => handleUserUnFocus('memberId', e),
              floatLabel: inputStates?.memberId?.isFocused || inputStates?.memberId?.hasValue,
              hideLabel: true,
              ...(inputStates?.memberId?.isFocused ? { placeholder: '' } : {}),
              fieldInFocus: inputStates?.memberId?.isFocused,
              required: true,
              disabled: loading,
            }} />
          </Col>
          {['SHAI', 'MDSV', 'HERITAGE'].includes(shortName)
            &&
            <Col md={14} className="beneficiary-search-using">
              <FormTextInput detail={{
                ...commonDetails,
                key: 'patientName',
                label: 'Patient Name',
                smallFloatLabel : BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                isLoading, isName: true, isMaxLengthNotApplicable: true,
                rules: [
                  { max: 50,
                  message: BENEF_CONSTANTS.PATIENT_NAME_MAX_LIMIT},
                ],
                className: 'HISSearchUI',
                onFocus: (): any => handleUserFocus('patientName'),
                onBlur: (e: any): any => handleUserUnFocus('patientName', e),
                floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
                hideLabel: true,
                placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
                smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                fieldInFocus: inputStates?.patientName?.isFocused,
                required: true,
                disabled: loading,
              }} />
            </Col>
          }
          {((shortName === 'CARE')) &&
            <Col md={10} className="align-care-doa">
              <FormInputDate
              detail={{
                ...commonDetails,
                key: 'dateOfAdmission',
                className: 'care-doa',
                customIcon: !inputStates?.dateOfAdmission?.hasValue,
                fieldInFocus: inputStates?.dateOfAdmission?.isFocused,
                onFocus: (): any => handleUserFocus('dateOfAdmission'),
                onBlur: (e: any): any => handleUserUnFocus('dateOfAdmission', e),
              }} />
            </Col>
          }
        </Row>
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[1]) {
      return <React.Fragment>
        <Row gutter={GUTTOR_SPACE}>
          {(shortName === 'SHAI') &&
            <Col md={24}>
              <Row gutter={GUTTOR_SPACE} className="star-radio-row">
                <Col md={12}>
                  <FormRadioButton detail={{
                    ...commonDetails,
                    key: 'employeeCorporateBeneficiaryRadio',
                    options: ['Employee ID', 'Corporate Name'],
                    onChange: onSelectRadio,
                    defaultValue: 'Employee ID',
                    defaultChecked: true,
                    disabled: loading,
                  }} />
                </Col>
              {enableRadio === 'employeeId' ?
                <Col md={12} className="star-field-margin">
                  <FormTextInput detail={{
                    ...commonDetails,
                    key: 'employeeId',
                    isLoading,
                    regex: /[^a-zA-Z\d\-]*/gm,
                    className: 'HISSearchUI',
                    onFocus: (): any => handleUserFocus('employeeId'),
                    onBlur: (e: any): any => handleUserUnFocus('employeeId', e),
                    floatLabel: inputStates?.employeeId?.isFocused || inputStates?.employeeId?.hasValue,
                    hideLabel: true,
                    placeholder: inputStates?.employeeId?.isFocused ? '' : 'Enter Employee ID',
                    fieldInFocus: inputStates?.employeeId?.isFocused,
                    onChange: checkRequiredField,
                    required: true,
                    disabled: loading,
                  }} />
                </Col>
                : enableRadio === 'corporateName' &&
                <Col md={12} className="star-field-margin">
                  <FormTextInput detail={{
                    ...commonDetails,
                    key: 'corporateName',
                    isLoading,
                    maxLengthValue: maximumValue,
                    fieldLengthValue: fieldLength,
                    ...({ regex: CORPRATE_NAME_REGEX }),
                    className: 'HISSearchUI',
                    onFocus: (): any => handleUserFocus('corporateName'),
                    onBlur: (e: any): any => handleUserUnFocus('corporateName', e),
                    floatLabel: inputStates?.corporateName?.isFocused || inputStates?.corporateName?.hasValue,
                    hideLabel: true,
                    placeholder: inputStates?.corporateName?.isFocused ? '' : 'Enter Corporate Name',
                    fieldInFocus: inputStates?.corporateName?.isFocused,
                    onChange: checkRequiredField,
                    required: true,
                    disabled: loading,
                  }} />
                </Col>
              }
              </Row>
              <Row gutter={GUTTOR_SPACE} className="star-radio-row">
                <Col md={12}>
                  <FormRadioButton detail={{
                    ...commonDetails,
                    key: 'medicalPolicyBeneficiaryRadio',
                    options: ['Member ID', 'Policy No'],
                    onChange: onSelectFirstRadio,
                    defaultValue: 'Member ID',
                    defaultChecked: true,
                    starRadio: true,
                    className: 'horizontal',
                    disabled: loading,
                  }} />
                </Col>
                {(shortName === 'SHAI') &&
                <>
                  {enableFirstRadio === 'medicalId' ?
                  <Col md={10} className="star-field-margin">
                    <FormTextInput
                      detail={{
                        ...commonDetails,
                        key: 'memberId',
                        isLoading,
                        className: 'HISSearchUI',
                        onFocus: (): any => handleUserFocus('memberId'),
                        onBlur: (e: any): any => handleUserUnFocus('memberId', e),
                        floatLabel: inputStates?.memberId?.isFocused || inputStates?.memberId?.hasValue,
                        hideLabel: true,
                        ...(inputStates?.memberId?.isFocused ? { placeholder: '' } : {}),
                        fieldInFocus: inputStates?.memberId?.isFocused,
                        required: true,
                        disabled: loading,
                      }}
                    />
                  </Col> :
                  enableFirstRadio === 'policyNumber' &&
                  <Col md={10} className="star-field-margin">
                    <FormTextInput detail={{
                      ...commonDetails,
                      key: 'policyNumber',
                      labelClass: 'mb-0',
                      rules: [
                        otherPolicyValidation],
                      className: 'HISSearchUI',
                      onFocus: (): any => handleUserFocus('policyNumber'),
                      onBlur: (e: any): any => handleUserUnFocus('policyNumber', e),
                      floatLabel: inputStates?.policyNumber?.isFocused || inputStates?.policyNumber?.hasValue,
                      hideLabel: true,
                      placeholder: inputStates?.policyNumber?.isFocused ? '' : BENEF_CONSTANTS.POLICY_NUMBER_PLACEHOLDER,
                      fieldInFocus: inputStates?.policyNumber?.isFocused,
                      required: true,
                      disabled: loading,
                    }} />
                  </Col>}
                  <Col md={2} className="star-search pd-l5">
                    <Button
                      data-testid="beneficiary-search-button"
                      type={!disable ? undefined : 'primary'}
                      style={{width: 120, height: 36}}
                      htmlType="submit"
                      loading={loading}
                      className={`NA-his-next-button .HIS-top-10 benef-submit-btn`}
                      icon={<SearchIcon className="his-benef-search-icon"/>}
                    >
                      <span id="WA_MEMBER_SEARCH"/>
                    </Button>
                  </Col>
                </>
                }
              </Row>
            </Col>
          }
          {(shortName === 'SHAI') ? null : !insurerFields && shortName !== 'ICICI' &&
          <>
          <Col md={(shortName === 'CMSGI') ? 24 : (shortName === 'HERITAGE' || shortName === 'PHSI') ? 10 : 12}
            className={`beneficiary-search-using ${shortName === 'VOLO' || shortName === 'HERITAGE' ||
            shortName === 'PHSI' ? 'rbr-0 RPA-VOLO' : ''}`}>
            <FormTextInput detail={{
              ...commonDetails,
              key: 'employeeId',
              isLoading,
              regex: /[^a-zA-Z\d\-]*/gm,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('employeeId'),
              onBlur: (e: any): any => handleUserUnFocus('employeeId', e),
              floatLabel: inputStates?.employeeId?.isFocused || inputStates?.employeeId?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.employeeId?.isFocused ? '' : 'Enter Employee ID',
              fieldInFocus: inputStates?.employeeId?.isFocused,
              onChange: checkRequiredField,
              required: true,
              disabled: loading,
            }} />
          </Col>
            {shortName !== 'CMSGI' && shortName !== 'HERITAGE' && shortName !== 'PHSI' &&
            <Col md={12} className={`${shortName === 'VOLO' ? 'beneficiary-search-using' : 'RPA-member-id-only'}`}>
                <FormTextInput detail={{
                  ...commonDetails,
                  key: 'corporateName',
                  required: true,
                  isLoading,
                  maxLengthValue: maximumValue,
                  fieldLengthValue: fieldLength,
                  ...({ regex: CORPRATE_NAME_REGEX }),
                  className: 'HISSearchUI',
                  onFocus: (): any => handleUserFocus('corporateName'),
                  onBlur: (e: any): any => handleUserUnFocus('corporateName', e),
                  floatLabel: inputStates?.corporateName?.isFocused || inputStates?.corporateName?.hasValue,
                  hideLabel: true,
                  placeholder: inputStates?.corporateName?.isFocused ? '' : 'Enter Corporate Name',
                  fieldInFocus: inputStates?.corporateName?.isFocused,
                  onChange: checkRequiredField,
                  disabled: loading,
                }} />
              </Col>
            }</>
          }
          {(shortName === 'PHSI' || shortName === 'HERITAGE') &&
            <>
              {insurerFields &&
                <><FormTextInput detail={{
                  ...commonDetails,
                  key: 'insuranceCardNumber',
                  labelClass: 'mb-0',
                  required: (mandatoryFields === 'insuranceCardNumber'),
                  onChange: checkMandatoryFields,
                  className: 'HISSearchUI',
                  disabled: loading,
                }} /><FormTextInput detail={{
                  ...commonDetails,
                  key: 'policyNumber',
                  labelClass: 'mb-0',
                  required: (mandatoryFields === 'policyNumber'),
                  onChange: checkMandatoryFields,
                  rules: [otherPolicyValidation],
                  className: 'HISSearchUI',
                  disabled: loading,
                }} />
                <FormSelect detail={{
                  ...commonDetails,
                  key: 'insurerName',
                  options: (payerLookUp[uniqueIdentifier]?.insurerName || []),
                  showSearch: true,
                  required: true,
                  onChange: onInsurerNameChange,
                  placeholder: 'Search or Enter Insurer Name',
                  className: 'his-select Re-Design-RPA-field-Dropdown',
                  disabled: loading,
                  onFocus: (): any => handleUserFocus('insurerName'),
                  onBlur: (e: any): any => handleUserUnFocus('insurerName', e),
                  fieldInFocus: inputStates?.insurerName?.isFocused,
                }} />
                </>
            } {
                showCorporateName &&
                <>
                  <Col md={14}
                    className={`NA-corporate-dropdown`}>
                    <FormSelect detail={{
                      ...commonDetails,
                      key: 'corporateNameDropdown',
                      options: (payerLookUp[uniqueIdentifier]?.corporate_name || []),
                      showSearch: true,
                      required: true,
                      onChange: onCorporateNameChange,
                      className: 'his-select Re-Design-RPA-field-Dropdown',
                      placeholder: 'Enter Corporate Name',
                      suffixIcon: <DownArrow />,
                      disabled: loading,
                      onFocus: (): any => handleUserFocus('corporateNameDropdown'),
                      onBlur: (e: any): any => handleUserUnFocus('corporateNameDropdown', e),
                      fieldInFocus: inputStates?.corporateNameDropdown?.isFocused,
                    }} />
                  </Col>
                </>
              }
            </>
          }
          {(shortName === 'ICICI' || shortName === 'VOLO') && (
            <>{shortName === 'ICICI' &&
              <Col md={10} className={`beneficiary-search-using rbr-0 RPA-VOLO`} >
                <FormTextInput detail={{
                  ...commonDetails,
                  key: 'employeeId',
                  isLoading,
                  regex: /[^a-zA-Z\d\-]*/gm,
                  className: 'HISSearchUI',
                  onFocus: (): any => handleUserFocus('employeeId'),
                  onBlur: (e: any): any => handleUserUnFocus('employeeId', e),
                  floatLabel: inputStates?.employeeId?.isFocused || inputStates?.employeeId?.hasValue,
                  hideLabel: true,
                  placeholder: inputStates?.employeeId?.isFocused ? '' : 'Enter Employee ID',
                  fieldInFocus: inputStates?.employeeId?.isFocused,
                  onChange: checkRequiredField,
                  required: true,
                  disabled: loading,
                }} />
              </Col>
            }
            {!(shortName === 'VOLO' && selectedBenefSearch === 'Employee ID') &&
            <Col md={14}
            className={`${shortName === 'ICICI' && selectedBenefSearch === 'Employee ID' ? 'beneficiary-search-using' :
            'benef-search-patient-name RPA-patient-name'}`}>
              <FormTextInput detail={{
                ...commonDetails,
                key: 'patientName',
                label: 'Patient Name',
                smallFloatLabel : BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                rules: [
                  { max: 50, message: BENEF_CONSTANTS.PATIENT_NAME_MAX_LIMIT},
                ],
                isLoading,
                isName: true ,
                isMaxLengthNotApplicable: true,
                className: 'HISSearchUI',
                onFocus: (): any => handleUserFocus('patientName'),
                onBlur: (e: any): any => handleUserUnFocus('patientName', e),
                floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
                hideLabel: true,
                placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
                smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                fieldInFocus: inputStates?.patientName?.isFocused,
                required: true,
                disabled: loading,
              }} />
            </Col>}
          </>
          )}
        </Row>
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[2]) { // policy type for bajaj
      return <React.Fragment>
        <Row gutter={GUTTOR_SPACE}>
          {(shortName === 'Bajaj') &&
          <Col md={10} className="rpa-policy-type">
            <FormSelect
              detail={{
                ...commonDetails,
                key: 'policyType',
                allowClear: false,
                hidden: false,
                label: 'Policy Type',
                options: POLICY_TYPE_OPTIONS.CUSTOMER_TYPES,
                onChange: bajajFields,
                className: 'his-select Re-Design-RPA-field-Dropdown',
                suffixIcon: <DownArrow />,
                isRedesign: true,
                disabled: loading,
                onFocus: (): any => handleUserFocus('policyType'),
                onBlur: (e: any): any => handleUserUnFocus('policyType', e),
                fieldInFocus: inputStates?.policyType?.isFocused,
              }} />
          </Col>
          }
          {/* policy number fields to be visible only bajaj and star */}
          {(insurerBajajFields || POLICY_FIELD_FOR_RPA.includes(shortName)) &&
            <>
            <Col md={getPolicyNumberColumnWidth()}
              className={getPolicyNumberClassName()}
            >
              <FormTextInput detail={{
                ...commonDetails,
                key: 'policyNumber',
                isLoading,
                onChange: checkRequiredField,
                rules: [otherPolicyValidation],
                minLengthValue: getPayerConfigPropValue(minPropObj, 'MIN', 'policyNumber'),
                fieldLengthValue: [getPayerConfigPropValue(minPropObj, 'minimumLength', 'policyNumber')],
                isName: false,
                className: 'HISSearchUI',
                onFocus: (): any => handleUserFocus('policyNumber'),
                onBlur: (e: any): any => handleUserUnFocus('policyNumber', e),
                floatLabel: inputStates?.policyNumber?.isFocused || inputStates?.policyNumber?.hasValue,
                hideLabel: true,
                placeholder: inputStates?.policyNumber?.isFocused ? '' : BENEF_CONSTANTS.POLICY_NUMBER_PLACEHOLDER,
                fieldInFocus: inputStates?.policyNumber?.isFocused,
                required: true,
                disabled: loading,
              }} />
            </Col>
            </>}
          {/* employee id and mobile fields for bajaj */}
          {((shortName === 'Bajaj') && showBajajCorporateName) || (corporateOptionMDSV) &&
            <>
              <Col md={(shortName === 'MDSV') ? 14 : 7} className={`beneficiary-search-using ${(shortName === 'Bajaj') ? 'rbr-0' : ''}`} >
                <FormTextInput detail={{
                  ...commonDetails,
                  key: 'employeeId',
                  isLoading,
                  regex: /[^a-zA-Z\d\-]*/gm,
                  className: 'HISSearchUI',
                  onFocus: (): any => handleUserFocus('employeeId'),
                  onBlur: (e: any): any => handleUserUnFocus('employeeId', e),
                  floatLabel: inputStates?.employeeId?.isFocused || inputStates?.employeeId?.hasValue,
                  hideLabel: true,
                  placeholder: inputStates?.employeeId?.isFocused ? '' : 'Enter Employee ID',
                  fieldInFocus: inputStates?.employeeId?.isFocused,
                  onChange: checkRequiredField,
                  required: (requiredField === 'employeeId'),
                  disabled: loading,
                }} />
              </Col>
            {(!corporateOptionMDSV) &&
              <FormInputMobile detail={{
                ...commonDetails,
                key: 'mobile',
                required: (requiredField === 'mobile'),
                onChange: checkRequiredField,
                rightFooterText: null,
                disabled: loading,
                className: 'HISSearchUI',
              }} />}
            </>}
          {!['Bajaj', 'NIVA BUPA', 'CMSGI'].includes(shortName) &&
          !(shortName === 'MDSV' && selectedBenefSearch === 'Policy No.' && selectedPolicyType === 'Corporate') && <>
            <Col md={14}
            className={`${['MDSV', 'PHSI', 'SHAI', 'HERITAGE', 'ICICI'].includes(shortName) ? 'beneficiary-search-using' :
            'benef-search-patient-name RPA-patient-name'}`}>
              <FormTextInput detail={{
                ...commonDetails,
                key: 'patientName',
                label: 'Patient Name',
                isLoading,
                isName: true,
                isMaxLengthNotApplicable: true,
                smallFloatLabel : BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                rules: [ { max: 50, message: BENEF_CONSTANTS.PATIENT_NAME_MAX_LIMIT} ],
                className: 'HISSearchUI',
                onFocus: (): any => handleUserFocus('patientName'),
                onBlur: (e: any): any => handleUserUnFocus('patientName', e),
                floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
                hideLabel: true,
                placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
                smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                fieldInFocus: inputStates?.patientName?.isFocused,
                required: true,
                disabled: loading,
                }}/>
            </Col>
          </>}
          {/* Show certificate number field only when Policy No pattern is matched */}
          {isCertificateNoReq &&
          <Col md={12} className="beneficiary-search-using">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'certificateNumber',
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('certificateNumber'),
              onBlur: (e: any): any => handleUserUnFocus('certificateNumber', e),
              floatLabel: inputStates?.certificateNumber?.isFocused || inputStates?.certificateNumber?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.certificateNumber?.isFocused ? '' : 'Enter Certificate No.',
              fieldInFocus: inputStates?.certificateNumber?.isFocused,
              required: true,
              disabled: loading,
            }} />
          </Col>
          }
        </Row>
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_WITH_POLICYNAME[3]) {
      return <React.Fragment>
        <Row gutter={GUTTOR_SPACE}>
          <Col md={11} className="beneficiary-search-using rbr-0 RPA-VOLO">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'policyName',
              isLoading,
              isName: true,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('policyName'),
              onBlur: (e: any): any => handleUserUnFocus('policyName', e),
              floatLabel: inputStates?.policyName?.isFocused || inputStates?.policyName?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.policyName?.isFocused ? '' : BENEF_CONSTANTS.POLICY_NUMBER_PLACEHOLDER,
              fieldInFocus: inputStates?.policyName?.isFocused,
              required: true,
              disabled: loading,
            }} />
          </Col>
          <Col md={13} className={`beneficiary-search-using`} >
            <FormTextInput detail={{
              ...commonDetails,
              key: 'employeeId',
              isLoading,
              regex: /[^a-zA-Z\d\-]*/gm,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('employeeId'),
              onBlur: (e: any): any => handleUserUnFocus('employeeId', e),
              floatLabel: inputStates?.employeeId?.isFocused || inputStates?.employeeId?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.employeeId?.isFocused ? '' : 'Enter Employee ID',
              fieldInFocus: inputStates?.employeeId?.isFocused,
              onChange: checkRequiredField,
              required: true,
              disabled: loading,
            }} />
          </Col>
        </Row>
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_WITH_CORPORATENAME[2]) { // corporate name , mobile, employee id fields for bajaj
      return <React.Fragment>
        <Row gutter={GUTTOR_SPACE}>
          <FormTextInput detail={{
            ...commonDetails,
            key: 'corporateName',
            required: true,
            isLoading,
            className: 'HISSearchUI',
            disabled: loading,
          }} />
          <Col md={12} className="beneficiary-search-using">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'employeeId',
              isLoading,
              regex: /[^a-zA-Z\d\-]*/gm,
              className: 'HISSearchUI',
              onChange: checkRequiredField,
              onFocus: (): any => handleUserFocus('employeeId'),
              onBlur: (e: any): any => handleUserUnFocus('employeeId', e),
              floatLabel: inputStates?.employeeId?.isFocused || inputStates?.employeeId?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.employeeId?.isFocused ? '' : 'Enter Employee ID',
              fieldInFocus: inputStates?.employeeId?.isFocused,
              required: (requiredField === 'employeeId'),
              disabled: loading,
            }} />
          </Col>
          <Col md={12} className="beneficiary-search-using-mobile">
            <FormInputMobile
              detail={{
              ...commonDetails,
              key: 'mobile',
              onChange: checkRequiredField,
              onFocus: (): any => handleUserFocus('mobile'),
              onBlur: (e: any): any => handleUserUnFocus('mobile', e),
              floatLabel: inputStates?.mobile?.isFocused || inputStates?.mobile?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.mobile?.isFocused ? '' : BENEF_CONSTANTS.MOBILE_PLACEHOLDER,
              smallPlaceholder: BENEF_CONSTANTS.OPTIONAL_PLACEHOLDER,
              fieldInFocus: inputStates?.mobile?.isFocused,
              smallFloatLabel: BENEF_CONSTANTS.OPTIONAL_PLACEHOLDER,
              required: (requiredField === 'mobile'),
              disabled: loading,
              rightFooterText: null,
              className: 'HISSearchUI',
            }} />
          </Col>
        </Row>
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_COI[2]) {
      return <React.Fragment>
        <Row gutter={GUTTOR_SPACE}>
          <Col md={shortName === 'NIVA BUPA' ? 24 : 12} className="beneficiary-search-using">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'coiNumber',
              isLoading,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('coiNumber'),
              onBlur: (e: any): any => handleUserUnFocus('coiNumber', e),
              floatLabel: inputStates?.coiNumber?.isFocused || inputStates?.coiNumber?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.coiNumber?.isFocused ? '' : 'Enter COI No.',
              fieldInFocus: inputStates?.coiNumber?.isFocused,
              required: true,
              disabled: loading,
            }} />
          </Col>
          { (!(shortName === 'NIVA BUPA') &&
            showBajajCorporateName) &&
            <Col md={7} className="beneficiary-search-using ">
              <FormTextInput
                detail={{
                  ...commonDetails,
                  key: 'patientName',
                  label: 'Patient Name',
                  smallFLoatLabel : BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                  isLoading,
                  isName: true,
                  isMaxLengthNotApplicable: true,
                  className: 'HISSearchUI',
                  smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                  disabled: loading,
                  rules: [
                    {max: 50, message: BENEF_CONSTANTS.PATIENT_NAME_MAX_LIMIT},
                    ...(shortName === 'NIVA BUPA' ? [patientNameValidation] : []),
                  ],
                }}
              />
            </Col>
          }
        </Row>
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_WITH_CERTIFICATE_NO[2]) { // certificateNumber for Chola
      return <React.Fragment>
        <Row gutter={GUTTOR_SPACE}>
          {retailOptionsCMSGI &&
          <Col md={24} className="beneficiary-search-using">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'certificateNumber',
              isLoading,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('certificateNumber'),
              onBlur: (e: any): any => handleUserUnFocus('certificateNumber', e),
              floatLabel: inputStates?.certificateNumber?.isFocused || inputStates?.certificateNumber?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.certificateNumber?.isFocused ? '' : 'Enter Certificate No.',
              fieldInFocus: inputStates?.certificateNumber?.isFocused,
              required: true,
              disabled: loading,
            }} />
          </Col>
          }
        </Row>
      </React.Fragment>;
    } else {
      return null;
    }
  };
  const getSearchOption = (): any[] => {
    return (shortName === 'SHAI') ? BENEFICIARY_SEARCH_OPTION :
      (shortName === 'ICICI') ? BENEFICIARY_SEARCH_WITH_POLICYNAME : (['TATA AIG', 'GODIGIT'].includes(shortName)) ?
        BENEFICIARY_SEARCH_WITH_ONLY_MEMBERID : shortName === 'CARE' ? BENEFICIARY_SEARCH_WITH_ONLY_CLIENTID : (shortName === 'Bajaj') ?
          BENEFICIARY_SEARCH_WITH_CORPORATENAME : (shortName === 'NIVA BUPA') ?
            BENEFICIARY_SEARCH_OPTION_COI : ((shortName === 'CMSGI') && retailOptionsCMSGI) ?
              BENEFICIARY_SEARCH_WITH_CERTIFICATE_NO : (shortName === 'CMSGI') ?
                BENEFICIARY_SEARCH_WITHOUT_POLICY : (shortName === 'MDSV' || (shortName === 'HERITAGE' && !showCorporateName) ||
                 (shortName === 'VOLO' && !showCorporateName) || (shortName === 'VIDAL') || (shortName === 'PHSI' && !showCorporateName)) ?
                  BENEFICIARY_SEARCH_OPTION_ABHI : BENEFICIARY_SEARCH_WITHOUT_POLICY;
  };

  return <>
    <Form
      layout="vertical"
      form={benefForm}
      validateMessages={VALIDATE_MESSAGES}
      onFinish={onClickSearch}
      requiredMark="optional"
      onValuesChange={resetRPABenefSearch}
      noValidate={true}
      >
      <Row gutter={GUTTOR_SPACE} className="his-search-row-cont policy-type-cont">
        {(shortName === 'SHAI') &&
          <>
            <Col md={3} className="select-policy-type-div star-div"><div>I Have:</div></Col>
            <Col md={7}
            className="beneficiary-search-options RPA-beneficiary-dropdown-unrounded star-margin">
              <FormSelect
                detail={{
                  ...commonDetails,
                  allowClear: false,
                  key: 'iHave',
                  options: benefSearchFields ? benefSearchFields : [],
                  onChange: onSearchChange,
                  required: true,
                  className: 'his-select unrounded-right',
                  isRedesign: true,
                  suffixIcon: <DownArrow />,
                  hideLabel: true,
                  disabled: loading,
                }}
              />
            </Col>
            {selectedBenefSearch === 'Employee ID' &&
            <Col md={10} className="beneficiary-search-options RPA-patient-name star-margin">
              <FormTextInput detail={{
                ...commonDetails,
                key: 'patientName',
                label: 'Patient Name',
                smallFloatLabel : BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                rules: [ { max: 50, message: BENEF_CONSTANTS.PATIENT_NAME_MAX_LIMIT} ],
                isLoading,
                isName: true ,
                isMaxLengthNotApplicable: true,
                className: 'HISSearchUI',
                onFocus: (): any => handleUserFocus('patientName'),
                onBlur: (e: any): any => handleUserUnFocus('patientName', e),
                floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
                hideLabel: true,
                placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
                smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                fieldInFocus: inputStates?.patientName?.isFocused,
                required: true,
                disabled: loading,
              }} />
            </Col>}
          </>
        }
        {(['CMSGI', 'MDSV', 'HERITAGE', 'VOLO', 'PHSI'].includes(shortName)) &&
          <>
          <Col md={5} className="select-policy-type-div"><div>Select Policy Type:</div></Col>
          <Col md={9} className="RPA-beneficiary-dropdown-unrounded policy-type">
            <FormSelect detail={{
              ...commonDetails,
              key: 'policyType',
              showSearch: true,
              options: POLICY_TYPE_OPTIONS.SECTOR_TYPES,
              onChange: updateFields,
              className: 'his-select Re-Design-RPA-field-Dropdown',
              suffixIcon: <DownArrow />,
              isRedesign: true,
              hideLabel: true,
              required: true,
              disabled: loading,
              onFocus: (): any => handleUserFocus('policyType'),
              onBlur: (e: any): any => handleUserUnFocus('policyType', e),
              fieldInFocus: inputStates?.policyType?.isFocused,
            }} />
          </Col>
          {!retailOptionsCMSGI &&
          <Col md={10} className="beneficiary-search-options RPA-policy-only">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'policyNumber',
              isLoading,
              rules: [ otherPolicyValidation ],
              isName: false,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('policyNumber'),
              onBlur: (e: any): any => handleUserUnFocus('policyNumber', e),
              floatLabel: inputStates?.policyNumber?.isFocused || inputStates?.policyNumber?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.policyNumber?.isFocused ? '' : BENEF_CONSTANTS.POLICY_NUMBER_PLACEHOLDER,
              fieldInFocus: inputStates?.policyNumber?.isFocused,
              required: true,
              disabled: loading,
            }} />
          </Col>
          }</>
        }
        {(shortName === 'NIVA BUPA') &&
        <>
          <Col md={5} className="select-policy-type-div"><div>Select Policy Type:</div></Col>
          <Col md={9} className="RPA-beneficiary-dropdown-unrounded policy-type">
            <FormSelect detail={{
              ...commonDetails,
              key: 'policyType',
              allowClear: true,
              hidden: false,
              label: 'Select Policy Type',
              placeholder: 'Select',
              options: POLICY_TYPE_OPTIONS.CUSTOMER_TYPES,
              onChange: bajajFields,
              className: 'his-select Re-Design-RPA-field-Dropdown',
              suffixIcon: <DownArrow />,
              isRedesign: true,
              hideLabel: true,
              required: true,
              disabled: loading,
              onFocus: (): any => handleUserFocus('policyType'),
              onBlur: (e: any): any => handleUserUnFocus('policyType', e),
              fieldInFocus: inputStates?.policyType?.isFocused,
            }} />
          </Col>
        </>
        }
        {(shortName === 'NIVA BUPA' && showBajajCorporateName) &&
            <Col md={10} className="beneficiary-search-options RPA-policy-only">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'patientName',
              label: 'Patient Name',
              smallFloatLabel : BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
              isLoading, isName: true, isMaxLengthNotApplicable: true,
              rules: [
                { max: 50, message: BENEF_CONSTANTS.PATIENT_NAME_MAX_LIMIT},
                ...(shortName === 'NIVA BUPA' ? [patientNameValidation] : []),
              ],
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('patientName'),
              onBlur: (e: any): any => handleUserUnFocus('patientName', e),
              floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
              smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
              fieldInFocus: inputStates?.patientName?.isFocused,
              required: true,
              disabled: loading,
            }} />
          </Col>
        }
        {(shortName === 'FHPL') &&
        <>
          <Col md={4} className="select-policy-type-div"><div>Select Insurer:</div></Col>
          <Col md={20} className="RPA-beneficiary-dropdown-unrounded RPA-insurer-name">
            <FormSelect detail={{
              ...commonDetails,
              key: 'insurerName',
              options: (payerLookUp[uniqueIdentifier]?.insurerName || []),
              showSearch: true,
              onChange: onInsurerNameChange,
              className: 'his-select Re-Design-RPA-field-Dropdown',
              suffixIcon: <DownArrow />,
              isRedesign: true,
              hideLabel: true,
              required: true,
              placeholder: 'Search or Enter Insurer Name',
              disabled: loading,
              onFocus: (): any => handleUserFocus('insurerName'),
              onBlur: (e: any): any => handleUserUnFocus('insurerName', e),
              fieldInFocus: inputStates?.insurerName?.isFocused,
            }} />
          </Col>
        </>
        }
      </Row>
      <Row gutter={GUTTOR_SPACE} className="his-search-row-cont">
        {!(shortName === 'SHAI') &&
        <Col md={(['VIDAL', 'TNNHIS', 'Bajaj', 'VOLO', 'FHPL', 'ICICI'].includes(shortName) && selectedBenefSearch === 'Member ID') ||
        (shortName === 'CMSGI' || shortName === 'NIVA BUPA') ? 6 : 5}
          className={(['VIDAL', 'TNNHIS', 'Bajaj', 'ICICI'].includes(shortName) && selectedBenefSearch === 'Member ID') ?
          'RPA-beneficiary-dropdown-unrounded' : 'beneficiary-dropdown'}>
          <FormSelect
            detail={{
              ...commonDetails,
              allowClear: false,
              key: 'iHave',
              options: benefSearchFields ? benefSearchFields : [],
              onChange: onSearchChange,
              required: true,
              className: 'his-select unrounded-right',
              isRedesign: true,
              suffixIcon: <DownArrow />,
              disabled: loading,
            }}
          />
        </Col>}
        <Col md={(['VIDAL', 'TNNHIS', 'Bajaj', 'VOLO', 'FHPL', 'PHSI', 'ICICI'].includes(shortName) &&
        selectedBenefSearch === 'Member ID') ||
        (shortName === 'CMSGI' || shortName === 'NIVA BUPA') ? 10 :
        (shortName === 'SHAI' && selectedBenefSearch === 'Employee ID') ? 20 :
        ((shortName === 'VOLO' && selectedBenefSearch === 'Employee ID') ||
        (shortName === 'PHSI' && selectedBenefSearch === 'Policy No.') ||
        (shortName === 'ICICI' && (selectedBenefSearch === 'Employee ID' || selectedBenefSearch === 'Policy Name')) ||
        (shortName === 'MDSV' && selectedBenefSearch === 'Policy No.' && selectedPolicyType === 'Corporate')) ? 19 :
        (shortName === 'Bajaj' && selectedBenefSearch === 'Policy No.') ? 16 : 17}
          className={`beneficiary-search-options ${shortName === 'SHAI' ? 'mt-10' : ''}`}>
          {getSearchUI()}
        </Col>
        {!((shortName === 'VOLO' && selectedBenefSearch === 'Employee ID') ||
        (shortName === 'PHSI' && selectedBenefSearch === 'Policy No.') ||
        (shortName === 'SHAI' && selectedBenefSearch === 'Employee ID') ||
        (shortName === 'ICICI' && (selectedBenefSearch === 'Employee ID' || selectedBenefSearch === 'Policy Name')) ||
        (shortName === 'MDSV' && selectedBenefSearch === 'Policy No.' && selectedPolicyType === 'Corporate')) &&
        <Col md={2} className={`${shortName === 'SHAI' ? 'star-search' : 'his-beneficiary-search-button'}`}>
          <Button
            data-testid="beneficiary-search-button"
            type={!disable ? undefined : 'primary'}
            style={{width: 120, height: 36}}
            htmlType="submit"
            loading={loading}
            className={`NA-his-next-button .HIS-top-10 benef-submit-btn`}
            icon={<SearchIcon className="his-benef-search-icon"/>}
          >
            <span id="WA_MEMBER_SEARCH"/>
          </Button>
        </Col>
        }
      </Row>

      {((shortName === 'VOLO' && selectedBenefSearch === 'Employee ID') ||
        (shortName === 'PHSI' && selectedBenefSearch === 'Policy No.') ||
        (shortName === 'ICICI' && (selectedBenefSearch === 'Employee ID' || selectedBenefSearch === 'Policy Name')) ||
        (shortName === 'MDSV' && selectedBenefSearch === 'Policy No.' && selectedPolicyType === 'Corporate')) &&
        <Row gutter={GUTTOR_SPACE} className="additional-row-rpa">
          {((shortName === 'VOLO' && selectedBenefSearch === 'Employee ID') ||
          (shortName === 'MDSV' && selectedBenefSearch === 'Policy No.' && selectedPolicyType === 'Corporate')) &&
          <Col md={14} className="beneficiary-search-options RPA-patient-name">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'patientName',
              label: 'Patient Name',
              smallFloatLabel : BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
              rules: [ { max: 50, message: BENEF_CONSTANTS.PATIENT_NAME_MAX_LIMIT} ],
              isLoading,
              isName: true ,
              isMaxLengthNotApplicable: true,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('patientName'),
              onBlur: (e: any): any => handleUserUnFocus('patientName', e),
              floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
              smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
              fieldInFocus: inputStates?.patientName?.isFocused,
              disabled: loading,
              required: true,
            }} />
          </Col>}
          {(shortName === 'PHSI' && selectedBenefSearch === 'Policy No.') &&
            <>
              <Col md={4} className="beneficiary-search-options select-policy-type-div mt-35"><div>Select Insurer:</div></Col>
              <Col md={18} className="beneficiary-search-options RPA-beneficiary-dropdown-unrounded RPA-insurer-name">
                <FormSelect detail={{
                  ...commonDetails,
                  key: 'insurerName',
                  options: (payerLookUp[uniqueIdentifier]?.insurerName || []),
                  showSearch: true,
                  onChange: onInsurerNameChange,
                  className: 'his-select Re-Design-RPA-field-Dropdown',
                  suffixIcon: <DownArrow />,
                  hideLabel: true,
                  placeholder: 'Search or Enter Insurer Name',
                  disabled: loading,
                  required: true,
                  onFocus: (): any => handleUserFocus('insurerName'),
                  onBlur: (e: any): any => handleUserUnFocus('insurerName', e),
                  fieldInFocus: inputStates?.insurerName?.isFocused,
                }} />
              </Col>
            </>
          }
          {isShowPolicyNo &&
            <Col md={14} className="beneficiary-search-options RPA-patient-name">
              <FormTextInput detail={{
                ...commonDetails,
                key: 'policyNumber',
                isLoading,
                rules: [ otherPolicyValidation ],
                isName: false,
                className: 'HISSearchUI',
                onFocus: (): any => handleUserFocus('policyNumber'),
                onBlur: (e: any): any => handleUserUnFocus('policyNumber', e),
                floatLabel: inputStates?.policyNumber?.isFocused || inputStates?.policyNumber?.hasValue,
                hideLabel: true,
                placeholder: inputStates?.policyNumber?.isFocused ? '' : BENEF_CONSTANTS.POLICY_NUMBER_PLACEHOLDER,
                fieldInFocus: inputStates?.policyNumber?.isFocused,
                required: true,
                disabled: loading,
              }} />
            </Col>
          }
          <Col md={2} className="his-beneficiary-search-button">
            <Button
              data-testid="beneficiary-search-button"
              type={!disable ? undefined : 'primary'}
              style={{width: 120, height: 36}}
              htmlType="submit"
              loading={loading}
              className={`NA-his-next-button .HIS-top-10 benef-submit-btn`}
              icon={<SearchIcon className="his-benef-search-icon"/>}
            >
              <span id="WA_MEMBER_SEARCH"/>
            </Button>
          </Col>
        </Row>
      }
    </Form>
    </>;
};

export default RPABeneficiarySearchPanelRedesign;
